import { render, staticRenderFns } from "./chartBarAge.vue?vue&type=template&id=f6c68386&"
import script from "./chartBarAge.vue?vue&type=script&lang=js&"
export * from "./chartBarAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports